import React, { useState, useRef, useEffect } from "react";
import "../../styles/customComponents/CustomDropdown.css";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchLots,
  fetchProgrammes,
} from "../../redux/actions/immobilierActions";

const CustomDropdown = ({ options, placeholder = "Choisir..." }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState(placeholder);
  const dropdownRef = useRef(null);

  const toggleDropdown = () => setIsOpen((prev) => !prev);

  const { activeView } = useSelector((state) => state.immobilierReducer);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);
  const dispatch = useDispatch();
  const handleSort = (activeView, option) => {
    activeView === "lots" && dispatch(fetchLots(1, 25, option.value));
    activeView === "programmes" &&
      dispatch(fetchProgrammes(1, 25, option.value));
    activeView === "carte" && dispatch(fetchProgrammes(1, 25, option.value));
  };

  return (
    <div className="custom-dropdown t03" ref={dropdownRef}>
      <button className="dropdown-button t03" onClick={toggleDropdown}>
        {selectedOption}
      </button>
      {isOpen && (
        <ul className="dropdown-options t03">
          {options.map((option) => (
            <li
              key={option.value}
              className="dropdown-option"
              onClick={() => handleSort(activeView, option)}
            >
              {option.label}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default CustomDropdown;
